const PUBLIC_UPLOAD_DEFAULT_PATCH = Symbol.for('eInvitation.photoAlbumPublicUploadDefault.v1')

function enforcePublicUploadDefaults(root = document) {
  root.querySelectorAll?.('.epa-upload-form .epa-preview-privacy-select').forEach((select) => {
    select.value = 'public'
    select.disabled = true
    select.setAttribute('aria-hidden', 'true')
    select.tabIndex = -1
  })

  root.querySelectorAll?.('.epa-upload-form .epa-preview-privacy').forEach((control) => {
    control.hidden = true
    control.setAttribute('aria-hidden', 'true')
  })
}

export function installPhotoAlbumPublicUploadDefault() {
  if (typeof document === 'undefined' || globalThis[PUBLIC_UPLOAD_DEFAULT_PATCH]) return

  const start = () => {
    enforcePublicUploadDefaults(document)

    // The legacy upload optimizer may create its privacy select after React has
    // rendered a preview. Keep it present internally so its FormData hook sees
    // an explicit value, but make that value permanently public and hide the UI.
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue
          enforcePublicUploadDefaults(node.matches?.('.epa-preview-item') ? node : node)
        }
      }
      enforcePublicUploadDefaults(document)
    })

    observer.observe(document.documentElement, { childList: true, subtree: true })

    document.addEventListener('change', (event) => {
      const select = event.target?.closest?.('.epa-upload-form .epa-preview-privacy-select')
      if (!select) return
      select.value = 'public'
      event.stopPropagation()
    }, true)

    document.addEventListener('submit', (event) => {
      if (!event.target?.matches?.('.epa-upload-form')) return
      enforcePublicUploadDefaults(event.target)
    }, true)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true })
  } else {
    start()
  }

  globalThis[PUBLIC_UPLOAD_DEFAULT_PATCH] = true
}
